import { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Auth, recordListActions } from '../../config/configuration/react';
import { getPaginateSourcesApi } from '../../services/Form/getSourcesApi';

const calculatePageCount = (numberRecords, recordsPerPage) =>
  Math.ceil(Math.max(recordsPerPage, numberRecords) / recordsPerPage);

export const useFormSearch = () => {
  const dispatch = useDispatch();
  const records = useSelector((state) => state.recordList.records) || [];
  const currentPage = useSelector((state) => state.recordList.currentPage);
  const recordPerPage = useSelector((state) => state.recordList.recordPerPage);
  const counts = useSelector((state) => state.recordList.counts);
  const pageCount = calculatePageCount(counts.search, recordPerPage);
  const loading = useSelector((state) => state.recordList.loading);
  const error = useSelector((state) => state.recordList.error);
  const selectedPos = useSelector((state) => state.recordList.selectedPos);
  const showCta = records.length < recordPerPage - 1;
  const showPaginnation = records.length > 0 && pageCount > 1;
  let sort = useSelector((state) => state.recordList.sort);
  const [sourceList, setSourceList] = useState([]);
  const [sourceListLoading, setSourceListLoading] = useState(false);
  const [searchTextSource, setSearchTextSource] = useState('');
  const [searchTextConcession, setSearchTextConcession] = useState('');
  const [currentPageSource, setCurrentPageSource] = useState(1);
  const [offset, setOffset] = useState(0);
  const [totalPages, setTotalPages] = useState(null);
  const [postsPerPage, setPostPerPage] = useState(99);

  const searchCurrentTab = () => {
    dispatch(recordListActions.searchWithFilters());
  };

  const searchSource = useMemo(
    () =>
      _.debounce((value) => {
        setSourceListLoading(true);
        setSourceList([]);
        getPaginateSourcesApi({ offset: 0, postsPerPage: 99, source: value })
          .then((res) => {
            setSourceList(res.list);
            setOffset((perv) => perv + 100);
            setPostPerPage((perv) => perv + 100);
            setCurrentPageSource((perv) => perv + 1);
            setSourceListLoading(false);
          })
          .catch((err) => {
            if (err.name === 'AbortError') {
              setSourceListLoading(true);
            } else {
              setSourceList([]);
              setSourceListLoading(false);
            }
          });
      }, 1000),
    [],
  );

  const goToPage = (page) => {
    dispatch(recordListActions.goTopage(page));
    searchCurrentTab();
  };

  const setSort = (key) => {
    if (sort?.[0] === key && sort?.[1] === 'ASC') sort = [key, 'DESC'];
    else sort = [key, 'ASC'];
    dispatch(recordListActions.setSort(sort));
    searchCurrentTab();
  };

  useEffect(() => {
    dispatch(recordListActions.initSearchPage());
  }, []);

  const changePos = (pos) => {
    dispatch(recordListActions.changePos(pos));
  };

  return {
    records,
    goToPage,
    pageCount,
    currentPage,
    loading,
    error,
    showCta,
    showPaginnation,
    setSort,
    sort,
    showExportCta: Auth.isAllowedToCtaExport(),
    selectedPos,
    changePos,
    sourceList,
    setSourceList,
    searchSource,
    searchTextSource,
    searchTextConcession,
    setSearchTextSource,
    setSearchTextConcession,
    sourceListLoading,
    setSourceListLoading,
    currentPageSource,
    setCurrentPageSource,
    offset,
    setOffset,
    totalPages,
    setTotalPages,
    postsPerPage,
    setPostPerPage,
  };
};
